import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { HiArrowLeft } from "react-icons/hi";
import { FaWhatsapp } from "react-icons/fa";
import "./index.css";
import "../../site/site.css";
import MetaTag from "../../components/MetaTag/MetaTag";
import CustomLoader from "../../components/CustomLoader/index";
import SiteHeader from "../../site/SiteHeader";
import SiteFooter from "../../site/SiteFooter";
import { Eyebrow } from "../../site/Brand";
import { OFFICES, waLink } from "../../site/contacts";
import { localized, publicApi } from "../../api/client";
import { categoryLabel } from "../../utils/postCategories";
import { formatPostDate } from "../News/index";
import Error404 from "../Error404";

function NewsDetail() {
  const { id } = useParams();
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    publicApi
      .post(id)
      .then((data) => {
        setPost(data);
        publicApi.viewPost(id);
      })
      .catch(() => setPost(null))
      .finally(() => setLoading(false));
  }, [id]);

  if (!loading && !post) return <Error404 />;

  const title = post ? localized(lang, post.title_ru, post.title_en) : "";
  const content = post ? localized(lang, post.content_ru, post.content_en) : "";

  return (
    <>
      {post && (
        <MetaTag
          title={`${title} | RR Consulting & Property`}
          description={localized(lang, post.excerpt_ru, post.excerpt_en) || content}
          image={post.image_url || undefined}
          type="article"
        />
      )}
      <SiteHeader />
      <main>
        {loading && (
          <div className="page-head">
            <CustomLoader loading />
          </div>
        )}
        {post && (
          <article className="article">
            <div className="wrap article__narrow">
              <Link to="/news" className="pd-back">
                <HiArrowLeft /> {t("news.backToNews")}
              </Link>
              <Eyebrow>
                {[post.category && categoryLabel(t, post.category), formatPostDate(post.created_at, lang)].filter(Boolean).join(" · ")}
              </Eyebrow>
              <h1 className="article__title">{title}</h1>
              <p className="article__meta">
                {post.author} · {(post.views || 0) + 1} {t("news.views")}
              </p>
            </div>
            {post.image_url && (
              <div className="wrap">
                <div className="article__cover">
                  <img src={post.image_url} alt={title} />
                </div>
              </div>
            )}
            <div className="wrap article__narrow">
              <div className="article__body">
                {content.split("\n").map((paragraph, i) => paragraph.trim() && <p key={i}>{paragraph}</p>)}
              </div>
              <div className="article__cta">
                <h3 className="h3">{t("news.interestedTitle")}</h3>
                <p>{t("news.interestedText")}</p>
                <div className="catalog-empty__actions" style={{ justifyContent: "flex-start" }}>
                  <a className="btn-pill" href={waLink(OFFICES.dubai)} target="_blank" rel="noopener noreferrer">
                    <FaWhatsapp /> {t("site.cta.dubai")}
                  </a>
                  <a className="btn-pill btn-pill--ghost" href={waLink(OFFICES.istanbul)} target="_blank" rel="noopener noreferrer">
                    <FaWhatsapp /> {t("site.cta.istanbul")}
                  </a>
                </div>
              </div>
            </div>
          </article>
        )}
      </main>
      <SiteFooter />
    </>
  );
}

export default NewsDetail;
